var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2597_22706)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300 150C300 67.1573 232.843 0 150 0C67.1573 0 0 67.1573 0 150C0 232.843 67.1573 300 150 300C232.843 300 300 232.843 300 150Z",
    fill: "#01C37D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.75 175.405L99.4974 150.935C97.455 148.957 94.704 147.861 91.8552 147.861C89.0064 147.861 86.2554 148.957 84.213 150.935C82.1676 152.918 81 155.627 81 158.473C81 159.88 81.2862 161.27 81.8394 162.565C82.3926 163.859 83.2008 165.028 84.213 166.009L117.146 197.921C121.382 202.026 128.194 202.026 132.43 197.921L215.787 117.148C217.832 115.166 219 112.457 219 109.612C219 106.766 217.832 104.057 215.787 102.075C213.745 100.096 210.994 99 208.145 99C205.296 99 202.546 100.096 200.504 102.074L124.75 175.405Z",
    fill: "white",
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2597_22706"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 300,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessTick);
export default __webpack_public_path__ + "static/media/SuccessTick.859f93127baca25b62a40e9766854e19.svg";
export { ForwardRef as ReactComponent };